import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  downPayment: "10000",
  months: "36",
  monthlyPayment: "10000",
  securityDeposit: "10000",
  purchasePrice: "500000",
  interestRate: "12",
  carErrors: null,
  calculationResults: {
    carBuyCost: 0,
    carLeaseCost: 0,
    purchasePrice: 0,
    monthlyBuyPayment: 0,
    totalInterest: 0,
    totalLeasePayments: 0,
    securityDeposit: 0,
    downPayment: 0
  }
};

const carSlice = createSlice({
  name: "carCalculator",
  initialState: initialState,

  reducers: {
    setDownPayment: (state, action) => {
      state.downPayment = action.payload;
    },
    setMonths: (state, action) => {
      state.months = action.payload;
    },
    setMonthlyPayment: (state, action) => {
      state.monthlyPayment = action.payload;
    },
    setSecurityDeposit: (state, action) => {
      state.securityDeposit = action.payload;
    },
    setPurchasePrice: (state, action) => {
      state.purchasePrice = action.payload;
    },
    setInterestRate: (state, action) => {
      state.interestRate = action.payload;
    },
    setCarResult: (state, action) => {
      state.carResult = action.payload;
    },
    setCarCalculationResults: (state, action) => {
      state.calculationResults = action.payload;
    },
    setCarErrors: (state, action) => {
      state.carErrors = action.payload;
    },
    resetCarData: (state) => {
      return initialState;
    }
  }
});

export const { 
  setDownPayment, 
  setMonths, 
  setMonthlyPayment, 
  setSecurityDeposit,
  setPurchasePrice,
  setInterestRate,
  setCarResult,
  setCarCalculationResults,
  setCarErrors,resetCarData
} = carSlice.actions;

export default carSlice.reducer;